import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
export function Guarantee() {
  return <section className="border-b border-white/10 bg-ink-900" data-id="element-145" data-mp="20m4qnvskykwl">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-3xl" data-id="element-146" data-mp="24molgspolcfk">
        <div className="rounded-2xl border border-accent/25 bg-ink-800 p-5 sm:p-8" data-id="element-147" data-mp="29dwx7vehh9vw">
          <div className="flex items-center gap-3" data-id="element-148" data-mp="29frkhgd89e35">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent" data-id="element-149" data-mp="2ebyhukrk5h9h">
              <ShieldCheckIcon className="h-6 w-6 text-ink-950" aria-hidden="true" data-id="element-150" data-mp="2jat7o6ny0633" />
            </span>
            <h2 className="font-display text-xl uppercase leading-tight text-white sm:text-2xl" data-id="element-151" data-mp="2ocik9qqtcrta">
              Garanzia blindata di 7 giorni
            </h2>
          </div>

          <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-152" data-mp="txy5fup6bqht">
            <p data-id="element-153" data-mp="xxzwl9xa91iu">
              Sappiamo che acquistare su Internet può generare dubbi. Per questo vogliamo assumerci
              tutto il rischio.
            </p>
            <p data-id="element-154" data-mp="3sn9l59jzsld9">
              Scarica il Sistema Tecnico PRO 360™, esamina ogni sistema, esplora tutti i modelli e
              valuta come può aiutarti a organizzare meglio la tua attività.
            </p>
            <p className="text-white" data-id="element-155" data-mp="3dwk6tyb8iq56">
              Se nei prossimi 7 giorni ritieni che il sistema non mantenga ciò che promette,
              scrivici: ti rimborseremo il{' '}
              <strong className="font-semibold text-accent" data-id="element-156" data-mp="fctxj3qm43hx">100% del tuo denaro.</strong>
            </p>
            <p className="text-[14px] text-white/50 sm:text-[15px]" data-id="element-157" data-mp="adz83iy53gou">
              Senza moduli complicati. Senza telefonate. Senza domande scomode.
            </p>
          </div>

          <div className="mt-7" data-id="element-158" data-mp="he32xm4e5l0">
            <CtaButton label="Voglio provarlo senza rischi" data-id="element-159" data-mp="2q6pstdf6ivjc" />
          </div>
        </div>
      </div>
    </section>;
}